export const GET_URL = 'GTAXPRO_MANUAL/GET_TUTORIAL_URL';
export const LOADER_STATUS = 'GTAXPRO_MANUAL/LOADER_STATUS';

